import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    defaultMessage: 'Add Contact Phone Number',
    id: 'yfyElc',
    description: 'Title for the phone number capture modal',
  },
  submitButton: {
    defaultMessage: 'Save',
    id: 'dO8XZf',
    description: 'Button text to submit the phone number',
  },
  cancelButton: {
    defaultMessage: 'Close',
    id: 'hRYK2P',
    description: 'Button text to skip adding phone number',
  },
  successMessage: {
    defaultMessage: 'Phone number saved successfully',
    id: 'eU0ZFZ',
    description: 'Success notification message after saving phone number',
  },
  errorMessage: {
    defaultMessage: 'Failed to save phone number. Please try again.',
    id: 'IlJIYx',
    description: 'Error notification message when save fails',
  },
});
